<template>
  <div class="side-bar df fdc">
    <button class="button-sidebar" v-on:click="goTo('/profile')" v-bind:class="{'button-sidebar-active': page == 'profile'}">Profile</button>
    <button class="button-sidebar" v-on:click="goTo('/billing')" v-bind:class="{'button-sidebar-active': page == 'billing'}">Billing</button>
  </div>
</template>

<script>
import router from '../../router'

export default {
  name: 'SideBar',
  data () {
    return {
      // mode: 'login' // login/register
    }
  },
  props: ['page'],
  components: {

  },
  methods: {
    goTo (path) {
      router.push(path)
    }
  },
  computed: {

  },
  created () {
    // console.log('** Login Component Loaded')
  }
}
</script>

<style scoped lang="scss">
.side-bar {
  padding: 50px;
  width: 274px;
  background-color: white;
}

button {
  margin-bottom: 20px;
}
</style>
